module.exports = __webpack_public_path__ + "static/media/img-login.061bb2bf.png";